import { IconProps } from "../../utils/global-types/global-types";

const QuestionAndAnswerIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className || "w-[18px] h-[18px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M14.29 6.895v2.29a3.88 3.88 0 0 1-3.875 3.875H7.97c.405.375.945.595 1.535.595h2.665l1.395.88a.82.82 0 0 0 .815.02c.255-.14.41-.41.41-.7v-.475A2.3 2.3 0 0 0 16 11.36V9.115a2.29 2.29 0 0 0-1.71-2.22"
    ></path>
    <path
      fill="currentColor"
      d="M3.595 11.755v.725a.9.9 0 0 0 .46.785.9.9 0 0 0 .91-.025l1.88-1.18h3.57a2.88 2.88 0 0 0 2.875-2.875V6.22a2.88 2.88 0 0 0-2.875-2.875h-5.54A2.88 2.88 0 0 0 2 6.22v2.965c0 1.1.63 2.09 1.595 2.57m4.06-1.305c-.275 0-.5-.22-.5-.5 0-.275.22-.5.495-.5h.005c.275 0 .5.225.5.5 0 .28-.225.5-.5.5M6.63 5.305c.39-.31.9-.425 1.395-.31.595.135 1.07.61 1.21 1.21a1.63 1.63 0 0 1-.69 1.74.96.96 0 0 0-.4.795c0 .275-.225.5-.5.5a.5.5 0 0 1-.5-.5c0-.67.315-1.28.85-1.63a.64.64 0 0 0 .265-.68.634.634 0 0 0-1.01-.34c-.15.12-.235.3-.235.495 0 .275-.225.5-.5.5-.28 0-.5-.225-.5-.5 0-.5.225-.965.615-1.28"
    ></path>
  </svg>
);

export default QuestionAndAnswerIcon;
